import { LogoutConfirmHost } from 'components/LogoutConfirm/LogoutConfirm';
import { Outlet, useLocation, useMatches, useNavigate } from 'react-router';
import { useEffect } from 'react';

import { RoleFavicon } from 'components/RoleFavicon/RoleFavicon';
import { isAuthSessionActive, useAuthSession } from 'hooks/useAuthSession';
import { useSyncRoleFromSession } from 'hooks/useSyncRoleFromSession';
import { OpenChatProvider } from 'modules/ChatV2/store/OpenChatContext';

import classes from './PageWrapper.module.scss';
import { Footer } from '../../components/Footer/Footer';
import { HeaderError } from '../../components/Header/HeaderError';
import { HeaderStudent } from '../../components/Header/HeaderStudent';
import { HeaderTeacher } from '../../components/Header/HeaderTeacher';

export const PageWrapper = () => {
  useSyncRoleFromSession();

  const { pathname } = useLocation();
  const matches = useMatches();
  const navigate = useNavigate();
  const { data: session, isError: sessionIsError } = useAuthSession();
  const sessionUnavailable =
    sessionIsError &&
    !isAuthSessionActive(session) &&
    (pathname.startsWith('/teacher') || pathname.startsWith('/profile') || pathname === '/');

  useEffect(() => {
    const onNavigate = (event: Event) => {
      const href = (event as CustomEvent<{ href?: string }>).detail?.href;
      if (typeof href === 'string' && href.startsWith('/')) {
        navigate(href);
      }
    };
    window.addEventListener('myteacher:navigate', onNavigate);
    return () => window.removeEventListener('myteacher:navigate', onNavigate);
  }, [navigate]);

  const isTeacherPath = !sessionUnavailable && pathname.startsWith('/teacher');
  const isStudentPath = !sessionUnavailable && pathname.startsWith('/profile');
  const isErrorPath =
    sessionUnavailable ||
    pathname.startsWith('/ErrorPage') ||
    matches.some((match) => (match.handle as { chrome?: string } | undefined)?.chrome === 'error');
  const hideChrome =
    pathname === '/passport-capture-test' || pathname === '/passport-confirm';

  return (
    <OpenChatProvider>
      <RoleFavicon />
      <LogoutConfirmHost />
      <div className={classes.root}>
        {!hideChrome && isTeacherPath && <HeaderTeacher />}
        {!hideChrome && isStudentPath && <HeaderStudent />}
        {!hideChrome && isErrorPath && <HeaderError />}
        <div className={classes.pageContent}>
          <Outlet />
        </div>
        {!hideChrome && <Footer />}
      </div>
    </OpenChatProvider>
  );
};
